
import { useMemo } from "react";

export function useMarkets(masterData: any[] = [], adData: any[] = [], atpData: any[] = []) {
  // Collate all unique market country codes from all tables, omitting falsy/empty
  return useMemo(() => {
    const all = [
      ...masterData.map((m) => m.market),
      ...adData.map((m) => m.market),
      ...atpData.map((m) => m.market),
    ]
      .filter((v) => !!v && v !== "all")
      .map((v) => v.trim())
      .filter(Boolean);

    return Array.from(new Set(all));
  }, [masterData, adData, atpData]);
}
